'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { IssuePage } from '../-components/IssuePage';
export const Route = createFileRoute('/_staff/labor-core/_egov-mock/certificate-issuance/issue/')({
  component: IssuePage
});